import { render } from "./news-desc.vue?vue&type=template&id=b775cc48&scoped=true"
import script from "./news-desc.vue?vue&type=script&lang=js"
export * from "./news-desc.vue?vue&type=script&lang=js"

import "./news-desc.vue?vue&type=style&index=0&id=b775cc48&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b775cc48"]])

export default __exports__